import apiClient from '../config/axiosConfig'; // eslint-disable-line
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error, true);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function getWaffleToken() {
    return function (dispatch) {
        dispatch({
            type: types.GET_WAFFLE_TOKEN_PENDING,
        });
        return apiClient.get('/v2/waffle')
            .then((response) => {
                dispatch({
                    type: types.GET_WAFFLE_TOKEN_SUCCESS,
                    payload: response.data,
                });
                if (response.data.data === '') {
                    setTimeout(() => {
                        dispatch(getWaffleToken());
                    }, 5000);
                }
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_WAFFLE_TOKEN_FAILED);
            });
    };
}
